import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramEventFragment on ComplianceProgramEventNode {
    id
    verb
    source
    channel
    status
    error
    payload
    created
    actor {
      id
      name
      avatar
    }
    target {
      id
      name
      avatar
    }
  }

  query getComplianceProgramEvents(
    $complianceProgramId: Int!
    $verbPrefixIn: [String]
    $batch: String
    $orderBy: String
    $after: String
  ) {
    complianceProgram(pk: $complianceProgramId) {
      id
      created
      events(
        verbPrefixIn: $verbPrefixIn
        batch: $batch
        orderBy: $orderBy
        first: 50
        after: $after
      ) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...ComplianceProgramEventFragment
          }
        }
      }
    }
  }
`;
